import { render } from "./Search.vue?vue&type=template&id=2a688207&scoped=true&ts=true"
import script from "./Search.vue?vue&type=script&lang=ts"
export * from "./Search.vue?vue&type=script&lang=ts"

import "./Search.vue?vue&type=style&index=0&id=2a688207&scoped=true&lang=scss"

import exportComponent from "/builds/maqqie/maqqie-client-portal/clientportal-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a688207"]])

export default __exports__